import src from "IMAGE";
export default { src, width: 1219, height: 376, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAARklEQVR42gWAUQ5AIBiAu/+dzIMz0Lww1kI1jH5Ztj5TV4x0s2eyDm08NuwMS0DizZdflKRMpS3jdlLrldYcNL1DngSl8AOsWzugnlVF9gAAAABJRU5ErkJggg=="};
